import { render, staticRenderFns } from "./workgroupmain.vue?vue&type=template&id=adb38d88&scoped=true"
import script from "./workgroupmain.vue?vue&type=script&lang=js"
export * from "./workgroupmain.vue?vue&type=script&lang=js"
import style0 from "./workgroupmain.vue?vue&type=style&index=0&id=adb38d88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adb38d88",
  null
  
)

export default component.exports